// extracted by mini-css-extract-plugin
module.exports = {"container":"TinkoffButton__container___3-yoW","container--small":"TinkoffButton__container--small___3M3Pt","container--gray":"TinkoffButton__container--gray___3NHJp"};